export default __webpack_public_path__ + "static/media/007.2cc68395.jpg";